import React, { useEffect, useState } from 'react';
import CustomContainer from '../../components/CustomContainer';
import { Actions } from '../../../client/Actions';
import HouseDetails from '../house/HouseDetails';
import OfferSummary from './result/OfferSummary';
import SearchHouse from '../../components/lakeview/searchHouse/SearchHouse';
import DivBetween from '../../components/div/DivBetween';
import LightButton from '../../components/button/LightButton';
import { useOffer } from '../../context/OfferProvider';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TrickButton from '../../components/button/TrickButton';
import DivEnd from '../../components/div/DivEnd';

const HouseOfferPage = () => {
  const location = useLocation(); // ✅ get current location
  const navigate = useNavigate();
  const { id } = useParams();
  const { house, setHouse, offerResult, setOfferResult, setCanModifyPayments } =
    useOffer();

  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    setCanModifyPayments(false);
    Actions.get('house/' + id, setHouse);
  }, [id, setCanModifyPayments]);

  return (
    <CustomContainer
      title={
        <DivBetween className={'w-100'}>
          <h4>Nowa rezerwacja</h4>
          <DivEnd className={'gap-2'}>
            <LightButton show={!editMode} onClick={() => setEditMode(true)}>
              Zmień
            </LightButton>
            <TrickButton text="Na tym etapie możesz jeszcze edytować długość pobytu oraz liczbę gości, aby lepiej dopasować rezerwację do potrzeb klienta." />
          </DivEnd>
        </DivBetween>
      }
    >
      <HouseDetails house={house} width={8} />

      {!!offerResult?.result && !editMode && (
        <OfferSummary
          key={offerResult?.result.uuid}
          show={!editMode}
          width={4}
          offer={offerResult.result}
          nextLabel={'Dalej'}
          onClickNext={() => {
            navigate({
              pathname: `/checkout/${id}`,
              search: location.search, // ✅ this now works
            });
          }}
        />
      )}

      <SearchHouse
        key={id}
        houseId={id}
        setResult={setOfferResult}
        show={editMode}
        onReset={() => setEditMode(false)}
        onSearchHouse={() => setEditMode(false)}
      />
    </CustomContainer>
  );
};

export default HouseOfferPage;
